<template>
  <div class="playing flex justify-center items-center p-3 border-box w-full h-full m-auto">
    <span class="playing__bar playing__bar1 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar2 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar3 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar4 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar5 rounded-xl ml-1 bg-white inline-block"></span>
  </div>
</template>

<style lang="scss" scoped>
.playing__bar {
  width: 4px;
  height: 4px;
  animation: up-and-down 1.3s ease infinite alternate;
}

.playing__bar1 {
  height: 27px;
}

.playing__bar2 {
  height: 22px;
  animation-delay: -2.2s;
}

.playing__bar3 {
  height: 18px;
  animation-delay: -3.7s;
}

.playing__bar4 {
  height: 13px;
  animation-delay: -4.3s;
}

.playing__bar5 {
  height: 4px;
  animation-delay: -4.9s;
}

@keyframes up-and-down {
  10% {
    height: 4px;
  }

  30% {
    height: 20px;
  }

  60% {
    height: 10px;
  }

  80% {
    height: 15px;
  }

  100% {
    height: 27px;
  }
}
</style>
